import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function ProductHero() {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden bg-slate-50" data-id="element-355">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-356">
        <div className="max-w-4xl mx-auto text-center" data-id="element-357">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-sm font-medium mb-8 border border-blue-100" data-id="element-358">
            <span className="w-2 h-2 rounded-full bg-blue-600" data-id="element-359" />
            Global Money Infrastructure
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-3xl sm:text-5xl md:text-7xl font-bold tracking-tight text-slate-900 mb-6 leading-[1.1]" data-id="element-360">
            A unified infrastructure for modern money movement.
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-base sm:text-xl text-slate-600 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-361">
            Orchestrate and connect payments, wallets, FX, liquidity,
            compliance, and programmable money through one platform and
            regulated rails.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-362">
            <a href="#solutions" data-id="element-363">
              <Button size="lg" className="w-full sm:w-auto min-w-[160px]" data-id="element-364">
                View Solutions
                <ArrowRight className="ml-2 w-4 h-4" data-id="element-365" />
              </Button>
            </a>
            <a href="mailto:sales@obseq.xyz" data-id="element-366">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto min-w-[160px]" data-id="element-367">
                Talk to Sales
              </Button>
            </a>
          </motion.div>
        </div>
      </div>

      {/* Background Elements */}
      <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none" data-id="element-368">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-gradient-to-b from-white to-transparent rounded-[100%] opacity-80 blur-3xl" data-id="element-369" />
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-blue-50 rounded-full blur-3xl opacity-40" data-id="element-370" />
        <div className="absolute top-1/3 right-0 w-96 h-96 bg-indigo-50 rounded-full blur-3xl opacity-40" data-id="element-371" />
      </div>
    </section>;
}